"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateFinalNegotiationActivityDto = void 0;
const mapped_types_1 = require("@nestjs/mapped-types");
const create_final_negotiation_activity_dto_1 = require("./create-final-negotiation-activity.dto");
class UpdateFinalNegotiationActivityDto extends (0, mapped_types_1.PartialType)(create_final_negotiation_activity_dto_1.CreateFinalNegotiationActivityDto) {
}
exports.UpdateFinalNegotiationActivityDto = UpdateFinalNegotiationActivityDto;
